/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 0.0.0
 * source: jetpack/proto/runtime/v1alpha1/remote.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../../../../google/protobuf/timestamp";
import * as pb_1 from "google-protobuf";
import * as grpc_1 from "@grpc/grpc-js";
export namespace remote {
    export enum ErrorCode {
        UNKNOWN = 0,
        SYSTEM = 100,
        APPLICATION = 200
    }
    export enum Unit {
        UNKNOWN_UNIT = 0,
        SECONDS = 1,
        MINUTES = 2,
        HOURS = 3,
        DAYS = 4,
        WEEKS = 5
    }
    export enum DayOfWeek {
        UNKNOWN_DAY = 0,
        SUNDAY = 1,
        MONDAY = 2,
        TUESDAY = 3,
        WEDNESDAY = 4,
        THURSDAY = 5,
        FRIDAY = 6,
        SATURDAY = 7
    }
    export class RemoteCallRequest extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            qualified_symbol?: string;
            json_args?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("qualified_symbol" in data && data.qualified_symbol != undefined) {
                    this.qualified_symbol = data.qualified_symbol;
                }
                if ("json_args" in data && data.json_args != undefined) {
                    this.json_args = data.json_args;
                }
            }
        }
        get qualified_symbol() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set qualified_symbol(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get json_args() {
            return pb_1.Message.getField(this, 2) as string;
        }
        set json_args(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            qualified_symbol?: string;
            json_args?: string;
        }) {
            const message = new RemoteCallRequest({});
            if (data.qualified_symbol != null) {
                message.qualified_symbol = data.qualified_symbol;
            }
            if (data.json_args != null) {
                message.json_args = data.json_args;
            }
            return message;
        }
        toObject() {
            const data: {
                qualified_symbol?: string;
                json_args?: string;
            } = {};
            if (this.qualified_symbol != null) {
                data.qualified_symbol = this.qualified_symbol;
            }
            if (this.json_args != null) {
                data.json_args = this.json_args;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.qualified_symbol === "string" && this.qualified_symbol.length)
                writer.writeString(1, this.qualified_symbol);
            if (typeof this.json_args === "string" && this.json_args.length)
                writer.writeString(2, this.json_args);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RemoteCallRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RemoteCallRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.qualified_symbol = reader.readString();
                        break;
                    case 2:
                        message.json_args = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): RemoteCallRequest {
            return RemoteCallRequest.deserialize(bytes);
        }
    }
    export class RemoteCallResponse extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            json_results?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("json_results" in data && data.json_results != undefined) {
                    this.json_results = data.json_results;
                }
            }
        }
        get json_results() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set json_results(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            json_results?: string;
        }) {
            const message = new RemoteCallResponse({});
            if (data.json_results != null) {
                message.json_results = data.json_results;
            }
            return message;
        }
        toObject() {
            const data: {
                json_results?: string;
            } = {};
            if (this.json_results != null) {
                data.json_results = this.json_results;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.json_results === "string" && this.json_results.length)
                writer.writeString(1, this.json_results);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RemoteCallResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RemoteCallResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.json_results = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): RemoteCallResponse {
            return RemoteCallResponse.deserialize(bytes);
        }
    }
    export class CreateTaskRequest extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            task?: Task;
            /** @deprecated*/
            sdk_version?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("task" in data && data.task != undefined) {
                    this.task = data.task;
                }
                if ("sdk_version" in data && data.sdk_version != undefined) {
                    this.sdk_version = data.sdk_version;
                }
            }
        }
        get task() {
            return pb_1.Message.getWrapperField(this, Task, 1) as Task;
        }
        set task(value: Task) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        /** @deprecated*/
        get sdk_version() {
            return pb_1.Message.getField(this, 2) as string;
        }
        /** @deprecated*/
        set sdk_version(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            task?: ReturnType<typeof Task.prototype.toObject>;
            sdk_version?: string;
        }) {
            const message = new CreateTaskRequest({});
            if (data.task != null) {
                message.task = Task.fromObject(data.task);
            }
            if (data.sdk_version != null) {
                message.sdk_version = data.sdk_version;
            }
            return message;
        }
        toObject() {
            const data: {
                task?: ReturnType<typeof Task.prototype.toObject>;
                sdk_version?: string;
            } = {};
            if (this.task != null) {
                data.task = this.task.toObject();
            }
            if (this.sdk_version != null) {
                data.sdk_version = this.sdk_version;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.task !== undefined)
                writer.writeMessage(1, this.task, () => this.task.serialize(writer));
            if (typeof this.sdk_version === "string" && this.sdk_version.length)
                writer.writeString(2, this.sdk_version);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateTaskRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateTaskRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.task, () => message.task = Task.deserialize(reader));
                        break;
                    case 2:
                        message.sdk_version = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): CreateTaskRequest {
            return CreateTaskRequest.deserialize(bytes);
        }
    }
    export class CreateTaskResponse extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            task_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("task_id" in data && data.task_id != undefined) {
                    this.task_id = data.task_id;
                }
            }
        }
        get task_id() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set task_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            task_id?: string;
        }) {
            const message = new CreateTaskResponse({});
            if (data.task_id != null) {
                message.task_id = data.task_id;
            }
            return message;
        }
        toObject() {
            const data: {
                task_id?: string;
            } = {};
            if (this.task_id != null) {
                data.task_id = this.task_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.task_id === "string" && this.task_id.length)
                writer.writeString(1, this.task_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CreateTaskResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CreateTaskResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.task_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): CreateTaskResponse {
            return CreateTaskResponse.deserialize(bytes);
        }
    }
    export class CancelTaskRequest extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            task_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("task_id" in data && data.task_id != undefined) {
                    this.task_id = data.task_id;
                }
            }
        }
        get task_id() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set task_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            task_id?: string;
        }) {
            const message = new CancelTaskRequest({});
            if (data.task_id != null) {
                message.task_id = data.task_id;
            }
            return message;
        }
        toObject() {
            const data: {
                task_id?: string;
            } = {};
            if (this.task_id != null) {
                data.task_id = this.task_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.task_id === "string" && this.task_id.length)
                writer.writeString(1, this.task_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CancelTaskRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancelTaskRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.task_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): CancelTaskRequest {
            return CancelTaskRequest.deserialize(bytes);
        }
    }
    export class CancelTaskResponse extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            success?: boolean;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("success" in data && data.success != undefined) {
                    this.success = data.success;
                }
            }
        }
        get success() {
            return pb_1.Message.getField(this, 1) as boolean;
        }
        set success(value: boolean) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            success?: boolean;
        }) {
            const message = new CancelTaskResponse({});
            if (data.success != null) {
                message.success = data.success;
            }
            return message;
        }
        toObject() {
            const data: {
                success?: boolean;
            } = {};
            if (this.success != null) {
                data.success = this.success;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.success !== undefined)
                writer.writeBool(1, this.success);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CancelTaskResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CancelTaskResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.success = reader.readBool();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): CancelTaskResponse {
            return CancelTaskResponse.deserialize(bytes);
        }
    }
    export class PostResultRequest extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            exec_id?: string;
            result?: Result;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("exec_id" in data && data.exec_id != undefined) {
                    this.exec_id = data.exec_id;
                }
                if ("result" in data && data.result != undefined) {
                    this.result = data.result;
                }
            }
        }
        get exec_id() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set exec_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get result() {
            return pb_1.Message.getWrapperField(this, Result, 2) as Result;
        }
        set result(value: Result) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        static fromObject(data: {
            exec_id?: string;
            result?: ReturnType<typeof Result.prototype.toObject>;
        }) {
            const message = new PostResultRequest({});
            if (data.exec_id != null) {
                message.exec_id = data.exec_id;
            }
            if (data.result != null) {
                message.result = Result.fromObject(data.result);
            }
            return message;
        }
        toObject() {
            const data: {
                exec_id?: string;
                result?: ReturnType<typeof Result.prototype.toObject>;
            } = {};
            if (this.exec_id != null) {
                data.exec_id = this.exec_id;
            }
            if (this.result != null) {
                data.result = this.result.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.exec_id === "string" && this.exec_id.length)
                writer.writeString(1, this.exec_id);
            if (this.result !== undefined)
                writer.writeMessage(2, this.result, () => this.result.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PostResultRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PostResultRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.exec_id = reader.readString();
                        break;
                    case 2:
                        reader.readMessage(message.result, () => message.result = Result.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): PostResultRequest {
            return PostResultRequest.deserialize(bytes);
        }
    }
    export class PostResultResponse extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}) {
            const message = new PostResultResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): PostResultResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new PostResultResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): PostResultResponse {
            return PostResultResponse.deserialize(bytes);
        }
    }
    export class Task extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            namespace?: string;
            /** @deprecated*/
            hostname?: string;
            app_name?: string;
            project_id?: string;
            chart_revision?: string;
            qualified_symbol?: string;
            encoded_args?: Uint8Array;
            parent_task_id?: string;
            target_time?: dependency_1.google.protobuf.Timestamp;
            with_checkpointing?: boolean;
            task_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("namespace" in data && data.namespace != undefined) {
                    this.namespace = data.namespace;
                }
                if ("hostname" in data && data.hostname != undefined) {
                    this.hostname = data.hostname;
                }
                if ("app_name" in data && data.app_name != undefined) {
                    this.app_name = data.app_name;
                }
                if ("project_id" in data && data.project_id != undefined) {
                    this.project_id = data.project_id;
                }
                if ("chart_revision" in data && data.chart_revision != undefined) {
                    this.chart_revision = data.chart_revision;
                }
                if ("qualified_symbol" in data && data.qualified_symbol != undefined) {
                    this.qualified_symbol = data.qualified_symbol;
                }
                if ("encoded_args" in data && data.encoded_args != undefined) {
                    this.encoded_args = data.encoded_args;
                }
                if ("parent_task_id" in data && data.parent_task_id != undefined) {
                    this.parent_task_id = data.parent_task_id;
                }
                if ("target_time" in data && data.target_time != undefined) {
                    this.target_time = data.target_time;
                }
                if ("with_checkpointing" in data && data.with_checkpointing != undefined) {
                    this.with_checkpointing = data.with_checkpointing;
                }
                if ("task_id" in data && data.task_id != undefined) {
                    this.task_id = data.task_id;
                }
            }
        }
        get namespace() {
            return pb_1.Message.getField(this, 3) as string;
        }
        set namespace(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        /** @deprecated*/
        get hostname() {
            return pb_1.Message.getField(this, 6) as string;
        }
        /** @deprecated*/
        set hostname(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get app_name() {
            return pb_1.Message.getField(this, 10) as string;
        }
        set app_name(value: string) {
            pb_1.Message.setField(this, 10, value);
        }
        get project_id() {
            return pb_1.Message.getField(this, 12) as string;
        }
        set project_id(value: string) {
            pb_1.Message.setField(this, 12, value);
        }
        get chart_revision() {
            return pb_1.Message.getField(this, 11) as string;
        }
        set chart_revision(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get qualified_symbol() {
            return pb_1.Message.getField(this, 2) as string;
        }
        set qualified_symbol(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get encoded_args() {
            return pb_1.Message.getField(this, 4) as Uint8Array;
        }
        set encoded_args(value: Uint8Array) {
            pb_1.Message.setField(this, 4, value);
        }
        get parent_task_id() {
            return pb_1.Message.getField(this, 5) as string;
        }
        set parent_task_id(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get target_time() {
            return pb_1.Message.getWrapperField(this, dependency_1.google.protobuf.Timestamp, 7) as dependency_1.google.protobuf.Timestamp;
        }
        set target_time(value: dependency_1.google.protobuf.Timestamp) {
            pb_1.Message.setWrapperField(this, 7, value);
        }
        get with_checkpointing() {
            return pb_1.Message.getField(this, 9) as boolean;
        }
        set with_checkpointing(value: boolean) {
            pb_1.Message.setField(this, 9, value);
        }
        get task_id() {
            return pb_1.Message.getField(this, 8) as string;
        }
        set task_id(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            namespace?: string;
            hostname?: string;
            app_name?: string;
            project_id?: string;
            chart_revision?: string;
            qualified_symbol?: string;
            encoded_args?: Uint8Array;
            parent_task_id?: string;
            target_time?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
            with_checkpointing?: boolean;
            task_id?: string;
        }) {
            const message = new Task({});
            if (data.namespace != null) {
                message.namespace = data.namespace;
            }
            if (data.hostname != null) {
                message.hostname = data.hostname;
            }
            if (data.app_name != null) {
                message.app_name = data.app_name;
            }
            if (data.project_id != null) {
                message.project_id = data.project_id;
            }
            if (data.chart_revision != null) {
                message.chart_revision = data.chart_revision;
            }
            if (data.qualified_symbol != null) {
                message.qualified_symbol = data.qualified_symbol;
            }
            if (data.encoded_args != null) {
                message.encoded_args = data.encoded_args;
            }
            if (data.parent_task_id != null) {
                message.parent_task_id = data.parent_task_id;
            }
            if (data.target_time != null) {
                message.target_time = dependency_1.google.protobuf.Timestamp.fromObject(data.target_time);
            }
            if (data.with_checkpointing != null) {
                message.with_checkpointing = data.with_checkpointing;
            }
            if (data.task_id != null) {
                message.task_id = data.task_id;
            }
            return message;
        }
        toObject() {
            const data: {
                namespace?: string;
                hostname?: string;
                app_name?: string;
                project_id?: string;
                chart_revision?: string;
                qualified_symbol?: string;
                encoded_args?: Uint8Array;
                parent_task_id?: string;
                target_time?: ReturnType<typeof dependency_1.google.protobuf.Timestamp.prototype.toObject>;
                with_checkpointing?: boolean;
                task_id?: string;
            } = {};
            if (this.namespace != null) {
                data.namespace = this.namespace;
            }
            if (this.hostname != null) {
                data.hostname = this.hostname;
            }
            if (this.app_name != null) {
                data.app_name = this.app_name;
            }
            if (this.project_id != null) {
                data.project_id = this.project_id;
            }
            if (this.chart_revision != null) {
                data.chart_revision = this.chart_revision;
            }
            if (this.qualified_symbol != null) {
                data.qualified_symbol = this.qualified_symbol;
            }
            if (this.encoded_args != null) {
                data.encoded_args = this.encoded_args;
            }
            if (this.parent_task_id != null) {
                data.parent_task_id = this.parent_task_id;
            }
            if (this.target_time != null) {
                data.target_time = this.target_time.toObject();
            }
            if (this.with_checkpointing != null) {
                data.with_checkpointing = this.with_checkpointing;
            }
            if (this.task_id != null) {
                data.task_id = this.task_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.namespace === "string" && this.namespace.length)
                writer.writeString(3, this.namespace);
            if (typeof this.hostname === "string" && this.hostname.length)
                writer.writeString(6, this.hostname);
            if (typeof this.app_name === "string" && this.app_name.length)
                writer.writeString(10, this.app_name);
            if (typeof this.project_id === "string" && this.project_id.length)
                writer.writeString(12, this.project_id);
            if (typeof this.chart_revision === "string" && this.chart_revision.length)
                writer.writeString(11, this.chart_revision);
            if (typeof this.qualified_symbol === "string" && this.qualified_symbol.length)
                writer.writeString(2, this.qualified_symbol);
            if (this.encoded_args !== undefined)
                writer.writeBytes(4, this.encoded_args);
            if (typeof this.parent_task_id === "string" && this.parent_task_id.length)
                writer.writeString(5, this.parent_task_id);
            if (this.target_time !== undefined)
                writer.writeMessage(7, this.target_time, () => this.target_time.serialize(writer));
            if (this.with_checkpointing !== undefined)
                writer.writeBool(9, this.with_checkpointing);
            if (typeof this.task_id === "string" && this.task_id.length)
                writer.writeString(8, this.task_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Task {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Task();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 3:
                        message.namespace = reader.readString();
                        break;
                    case 6:
                        message.hostname = reader.readString();
                        break;
                    case 10:
                        message.app_name = reader.readString();
                        break;
                    case 12:
                        message.project_id = reader.readString();
                        break;
                    case 11:
                        message.chart_revision = reader.readString();
                        break;
                    case 2:
                        message.qualified_symbol = reader.readString();
                        break;
                    case 4:
                        message.encoded_args = reader.readBytes();
                        break;
                    case 5:
                        message.parent_task_id = reader.readString();
                        break;
                    case 7:
                        reader.readMessage(message.target_time, () => message.target_time = dependency_1.google.protobuf.Timestamp.deserialize(reader));
                        break;
                    case 9:
                        message.with_checkpointing = reader.readBool();
                        break;
                    case 8:
                        message.task_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): Task {
            return Task.deserialize(bytes);
        }
    }
    export class Result extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            value?: Value;
            error?: Error;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("value" in data && data.value != undefined) {
                    this.value = data.value;
                }
                if ("error" in data && data.error != undefined) {
                    this.error = data.error;
                }
            }
        }
        get value() {
            return pb_1.Message.getWrapperField(this, Value, 1) as Value;
        }
        set value(value: Value) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get error() {
            return pb_1.Message.getWrapperField(this, Error, 2) as Error;
        }
        set error(value: Error) {
            pb_1.Message.setWrapperField(this, 2, value);
        }
        static fromObject(data: {
            value?: ReturnType<typeof Value.prototype.toObject>;
            error?: ReturnType<typeof Error.prototype.toObject>;
        }) {
            const message = new Result({});
            if (data.value != null) {
                message.value = Value.fromObject(data.value);
            }
            if (data.error != null) {
                message.error = Error.fromObject(data.error);
            }
            return message;
        }
        toObject() {
            const data: {
                value?: ReturnType<typeof Value.prototype.toObject>;
                error?: ReturnType<typeof Error.prototype.toObject>;
            } = {};
            if (this.value != null) {
                data.value = this.value.toObject();
            }
            if (this.error != null) {
                data.error = this.error.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.value !== undefined)
                writer.writeMessage(1, this.value, () => this.value.serialize(writer));
            if (this.error !== undefined)
                writer.writeMessage(2, this.error, () => this.error.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Result {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Result();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.value, () => message.value = Value.deserialize(reader));
                        break;
                    case 2:
                        reader.readMessage(message.error, () => message.error = Error.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): Result {
            return Result.deserialize(bytes);
        }
    }
    export class Error extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            code?: ErrorCode;
            message?: string;
            encoded_error?: Uint8Array;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("code" in data && data.code != undefined) {
                    this.code = data.code;
                }
                if ("message" in data && data.message != undefined) {
                    this.message = data.message;
                }
                if ("encoded_error" in data && data.encoded_error != undefined) {
                    this.encoded_error = data.encoded_error;
                }
            }
        }
        get code() {
            return pb_1.Message.getField(this, 1) as ErrorCode;
        }
        set code(value: ErrorCode) {
            pb_1.Message.setField(this, 1, value);
        }
        get message() {
            return pb_1.Message.getField(this, 2) as string;
        }
        set message(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get encoded_error() {
            return pb_1.Message.getField(this, 3) as Uint8Array;
        }
        set encoded_error(value: Uint8Array) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            code?: ErrorCode;
            message?: string;
            encoded_error?: Uint8Array;
        }) {
            const message = new Error({});
            if (data.code != null) {
                message.code = data.code;
            }
            if (data.message != null) {
                message.message = data.message;
            }
            if (data.encoded_error != null) {
                message.encoded_error = data.encoded_error;
            }
            return message;
        }
        toObject() {
            const data: {
                code?: ErrorCode;
                message?: string;
                encoded_error?: Uint8Array;
            } = {};
            if (this.code != null) {
                data.code = this.code;
            }
            if (this.message != null) {
                data.message = this.message;
            }
            if (this.encoded_error != null) {
                data.encoded_error = this.encoded_error;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.code !== undefined)
                writer.writeEnum(1, this.code);
            if (typeof this.message === "string" && this.message.length)
                writer.writeString(2, this.message);
            if (this.encoded_error !== undefined)
                writer.writeBytes(3, this.encoded_error);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Error {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Error();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.code = reader.readEnum();
                        break;
                    case 2:
                        message.message = reader.readString();
                        break;
                    case 3:
                        message.encoded_error = reader.readBytes();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): Error {
            return Error.deserialize(bytes);
        }
    }
    export class Value extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            encoded_value?: Uint8Array;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("encoded_value" in data && data.encoded_value != undefined) {
                    this.encoded_value = data.encoded_value;
                }
            }
        }
        get encoded_value() {
            return pb_1.Message.getField(this, 1) as Uint8Array;
        }
        set encoded_value(value: Uint8Array) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            encoded_value?: Uint8Array;
        }) {
            const message = new Value({});
            if (data.encoded_value != null) {
                message.encoded_value = data.encoded_value;
            }
            return message;
        }
        toObject() {
            const data: {
                encoded_value?: Uint8Array;
            } = {};
            if (this.encoded_value != null) {
                data.encoded_value = this.encoded_value;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.encoded_value !== undefined)
                writer.writeBytes(1, this.encoded_value);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Value {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Value();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.encoded_value = reader.readBytes();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): Value {
            return Value.deserialize(bytes);
        }
    }
    export class RegisterAppRequest extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            namespace?: string;
            hostname?: string;
            cron_jobs?: CronJob[];
            qualified_symbols?: string[];
            endpoints?: Map<string, string>;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [4, 5], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("namespace" in data && data.namespace != undefined) {
                    this.namespace = data.namespace;
                }
                if ("hostname" in data && data.hostname != undefined) {
                    this.hostname = data.hostname;
                }
                if ("cron_jobs" in data && data.cron_jobs != undefined) {
                    this.cron_jobs = data.cron_jobs;
                }
                if ("qualified_symbols" in data && data.qualified_symbols != undefined) {
                    this.qualified_symbols = data.qualified_symbols;
                }
                if ("endpoints" in data && data.endpoints != undefined) {
                    this.endpoints = data.endpoints;
                }
            }
            if (!this.endpoints)
                this.endpoints = new Map();
        }
        get namespace() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set namespace(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get hostname() {
            return pb_1.Message.getField(this, 2) as string;
        }
        set hostname(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get cron_jobs() {
            return pb_1.Message.getRepeatedWrapperField(this, CronJob, 4) as CronJob[];
        }
        set cron_jobs(value: CronJob[]) {
            pb_1.Message.setRepeatedWrapperField(this, 4, value);
        }
        get qualified_symbols() {
            return pb_1.Message.getField(this, 5) as string[];
        }
        set qualified_symbols(value: string[]) {
            pb_1.Message.setField(this, 5, value);
        }
        get endpoints() {
            return pb_1.Message.getField(this, 6) as any as Map<string, string>;
        }
        set endpoints(value: Map<string, string>) {
            pb_1.Message.setField(this, 6, value as any);
        }
        static fromObject(data: {
            namespace?: string;
            hostname?: string;
            cron_jobs?: ReturnType<typeof CronJob.prototype.toObject>[];
            qualified_symbols?: string[];
            endpoints?: {
                [key: string]: string;
            };
        }) {
            const message = new RegisterAppRequest({});
            if (data.namespace != null) {
                message.namespace = data.namespace;
            }
            if (data.hostname != null) {
                message.hostname = data.hostname;
            }
            if (data.cron_jobs != null) {
                message.cron_jobs = data.cron_jobs.map(item => CronJob.fromObject(item));
            }
            if (data.qualified_symbols != null) {
                message.qualified_symbols = data.qualified_symbols;
            }
            if (typeof data.endpoints == "object") {
                message.endpoints = new Map(Object.entries(data.endpoints));
            }
            return message;
        }
        toObject() {
            const data: {
                namespace?: string;
                hostname?: string;
                cron_jobs?: ReturnType<typeof CronJob.prototype.toObject>[];
                qualified_symbols?: string[];
                endpoints?: {
                    [key: string]: string;
                };
            } = {};
            if (this.namespace != null) {
                data.namespace = this.namespace;
            }
            if (this.hostname != null) {
                data.hostname = this.hostname;
            }
            if (this.cron_jobs != null) {
                data.cron_jobs = this.cron_jobs.map((item: CronJob) => item.toObject());
            }
            if (this.qualified_symbols != null) {
                data.qualified_symbols = this.qualified_symbols;
            }
            if (this.endpoints.size > 0) {
                data.endpoints = Object.fromEntries(this.endpoints);
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.namespace === "string" && this.namespace.length)
                writer.writeString(1, this.namespace);
            if (typeof this.hostname === "string" && this.hostname.length)
                writer.writeString(2, this.hostname);
            if (this.cron_jobs !== undefined)
                writer.writeRepeatedMessage(4, this.cron_jobs, (item: CronJob) => item.serialize(writer));
            if (this.qualified_symbols !== undefined)
                writer.writeRepeatedString(5, this.qualified_symbols);
            for (const [key, value] of this.endpoints) {
                writer.writeMessage(6, this.endpoints, () => {
                    writer.writeString(1, key);
                    writer.writeString(2, value);
                });
            }
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RegisterAppRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RegisterAppRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.namespace = reader.readString();
                        break;
                    case 2:
                        message.hostname = reader.readString();
                        break;
                    case 4:
                        reader.readMessage(message.cron_jobs, () => pb_1.Message.addToRepeatedWrapperField(message, 4, CronJob.deserialize(reader), CronJob));
                        break;
                    case 5:
                        pb_1.Message.addToRepeatedField(message, 5, reader.readString());
                        break;
                    case 6:
                        reader.readMessage(message, () => pb_1.Map.deserializeBinary(message.endpoints as any, reader, reader.readString, reader.readString));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): RegisterAppRequest {
            return RegisterAppRequest.deserialize(bytes);
        }
    }
    export class RegisterAppResponse extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}) {
            const message = new RegisterAppResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): RegisterAppResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new RegisterAppResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): RegisterAppResponse {
            return RegisterAppResponse.deserialize(bytes);
        }
    }
    export class DeregisterAppRequest extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            namespace?: string;
            hostname?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("namespace" in data && data.namespace != undefined) {
                    this.namespace = data.namespace;
                }
                if ("hostname" in data && data.hostname != undefined) {
                    this.hostname = data.hostname;
                }
            }
        }
        get namespace() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set namespace(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get hostname() {
            return pb_1.Message.getField(this, 2) as string;
        }
        set hostname(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            namespace?: string;
            hostname?: string;
        }) {
            const message = new DeregisterAppRequest({});
            if (data.namespace != null) {
                message.namespace = data.namespace;
            }
            if (data.hostname != null) {
                message.hostname = data.hostname;
            }
            return message;
        }
        toObject() {
            const data: {
                namespace?: string;
                hostname?: string;
            } = {};
            if (this.namespace != null) {
                data.namespace = this.namespace;
            }
            if (this.hostname != null) {
                data.hostname = this.hostname;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.namespace === "string" && this.namespace.length)
                writer.writeString(1, this.namespace);
            if (typeof this.hostname === "string" && this.hostname.length)
                writer.writeString(2, this.hostname);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeregisterAppRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeregisterAppRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.namespace = reader.readString();
                        break;
                    case 2:
                        message.hostname = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): DeregisterAppRequest {
            return DeregisterAppRequest.deserialize(bytes);
        }
    }
    export class DeregisterAppResponse extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}) {
            const message = new DeregisterAppResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeregisterAppResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeregisterAppResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): DeregisterAppResponse {
            return DeregisterAppResponse.deserialize(bytes);
        }
    }
    export class WaitForResultRequest extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            task_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("task_id" in data && data.task_id != undefined) {
                    this.task_id = data.task_id;
                }
            }
        }
        get task_id() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set task_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            task_id?: string;
        }) {
            const message = new WaitForResultRequest({});
            if (data.task_id != null) {
                message.task_id = data.task_id;
            }
            return message;
        }
        toObject() {
            const data: {
                task_id?: string;
            } = {};
            if (this.task_id != null) {
                data.task_id = this.task_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.task_id === "string" && this.task_id.length)
                writer.writeString(1, this.task_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WaitForResultRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WaitForResultRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.task_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): WaitForResultRequest {
            return WaitForResultRequest.deserialize(bytes);
        }
    }
    export class WaitForResultResponse extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            result?: Result;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("result" in data && data.result != undefined) {
                    this.result = data.result;
                }
            }
        }
        get result() {
            return pb_1.Message.getWrapperField(this, Result, 1) as Result;
        }
        set result(value: Result) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        static fromObject(data: {
            result?: ReturnType<typeof Result.prototype.toObject>;
        }) {
            const message = new WaitForResultResponse({});
            if (data.result != null) {
                message.result = Result.fromObject(data.result);
            }
            return message;
        }
        toObject() {
            const data: {
                result?: ReturnType<typeof Result.prototype.toObject>;
            } = {};
            if (this.result != null) {
                data.result = this.result.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.result !== undefined)
                writer.writeMessage(1, this.result, () => this.result.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WaitForResultResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WaitForResultResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.result, () => message.result = Result.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): WaitForResultResponse {
            return WaitForResultResponse.deserialize(bytes);
        }
    }
    export class GetSymbolFromEndpointRequest extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            endpoint?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("endpoint" in data && data.endpoint != undefined) {
                    this.endpoint = data.endpoint;
                }
            }
        }
        get endpoint() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set endpoint(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            endpoint?: string;
        }) {
            const message = new GetSymbolFromEndpointRequest({});
            if (data.endpoint != null) {
                message.endpoint = data.endpoint;
            }
            return message;
        }
        toObject() {
            const data: {
                endpoint?: string;
            } = {};
            if (this.endpoint != null) {
                data.endpoint = this.endpoint;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.endpoint === "string" && this.endpoint.length)
                writer.writeString(1, this.endpoint);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSymbolFromEndpointRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSymbolFromEndpointRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.endpoint = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): GetSymbolFromEndpointRequest {
            return GetSymbolFromEndpointRequest.deserialize(bytes);
        }
    }
    export class GetSymbolFromEndpointResponse extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            symbol?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("symbol" in data && data.symbol != undefined) {
                    this.symbol = data.symbol;
                }
            }
        }
        get symbol() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set symbol(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            symbol?: string;
        }) {
            const message = new GetSymbolFromEndpointResponse({});
            if (data.symbol != null) {
                message.symbol = data.symbol;
            }
            return message;
        }
        toObject() {
            const data: {
                symbol?: string;
            } = {};
            if (this.symbol != null) {
                data.symbol = this.symbol;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.symbol === "string" && this.symbol.length)
                writer.writeString(1, this.symbol);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSymbolFromEndpointResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSymbolFromEndpointResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.symbol = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): GetSymbolFromEndpointResponse {
            return GetSymbolFromEndpointResponse.deserialize(bytes);
        }
    }
    export class CronJob extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            qualified_symbol?: string;
            target_time?: string;
            target_day_of_week?: DayOfWeek;
            unit?: Unit;
            interval?: number;
            schedule_rule?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("qualified_symbol" in data && data.qualified_symbol != undefined) {
                    this.qualified_symbol = data.qualified_symbol;
                }
                if ("target_time" in data && data.target_time != undefined) {
                    this.target_time = data.target_time;
                }
                if ("target_day_of_week" in data && data.target_day_of_week != undefined) {
                    this.target_day_of_week = data.target_day_of_week;
                }
                if ("unit" in data && data.unit != undefined) {
                    this.unit = data.unit;
                }
                if ("interval" in data && data.interval != undefined) {
                    this.interval = data.interval;
                }
                if ("schedule_rule" in data && data.schedule_rule != undefined) {
                    this.schedule_rule = data.schedule_rule;
                }
            }
        }
        get qualified_symbol() {
            return pb_1.Message.getField(this, 3) as string;
        }
        set qualified_symbol(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get target_time() {
            return pb_1.Message.getField(this, 4) as string;
        }
        set target_time(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get target_day_of_week() {
            return pb_1.Message.getField(this, 5) as DayOfWeek;
        }
        set target_day_of_week(value: DayOfWeek) {
            pb_1.Message.setField(this, 5, value);
        }
        get unit() {
            return pb_1.Message.getField(this, 6) as Unit;
        }
        set unit(value: Unit) {
            pb_1.Message.setField(this, 6, value);
        }
        get interval() {
            return pb_1.Message.getField(this, 7) as number;
        }
        set interval(value: number) {
            pb_1.Message.setField(this, 7, value);
        }
        get schedule_rule() {
            return pb_1.Message.getField(this, 8) as string;
        }
        set schedule_rule(value: string) {
            pb_1.Message.setField(this, 8, value);
        }
        static fromObject(data: {
            qualified_symbol?: string;
            target_time?: string;
            target_day_of_week?: DayOfWeek;
            unit?: Unit;
            interval?: number;
            schedule_rule?: string;
        }) {
            const message = new CronJob({});
            if (data.qualified_symbol != null) {
                message.qualified_symbol = data.qualified_symbol;
            }
            if (data.target_time != null) {
                message.target_time = data.target_time;
            }
            if (data.target_day_of_week != null) {
                message.target_day_of_week = data.target_day_of_week;
            }
            if (data.unit != null) {
                message.unit = data.unit;
            }
            if (data.interval != null) {
                message.interval = data.interval;
            }
            if (data.schedule_rule != null) {
                message.schedule_rule = data.schedule_rule;
            }
            return message;
        }
        toObject() {
            const data: {
                qualified_symbol?: string;
                target_time?: string;
                target_day_of_week?: DayOfWeek;
                unit?: Unit;
                interval?: number;
                schedule_rule?: string;
            } = {};
            if (this.qualified_symbol != null) {
                data.qualified_symbol = this.qualified_symbol;
            }
            if (this.target_time != null) {
                data.target_time = this.target_time;
            }
            if (this.target_day_of_week != null) {
                data.target_day_of_week = this.target_day_of_week;
            }
            if (this.unit != null) {
                data.unit = this.unit;
            }
            if (this.interval != null) {
                data.interval = this.interval;
            }
            if (this.schedule_rule != null) {
                data.schedule_rule = this.schedule_rule;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.qualified_symbol === "string" && this.qualified_symbol.length)
                writer.writeString(3, this.qualified_symbol);
            if (typeof this.target_time === "string" && this.target_time.length)
                writer.writeString(4, this.target_time);
            if (this.target_day_of_week !== undefined)
                writer.writeEnum(5, this.target_day_of_week);
            if (this.unit !== undefined)
                writer.writeEnum(6, this.unit);
            if (this.interval !== undefined)
                writer.writeInt64(7, this.interval);
            if (typeof this.schedule_rule === "string" && this.schedule_rule.length)
                writer.writeString(8, this.schedule_rule);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CronJob {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CronJob();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 3:
                        message.qualified_symbol = reader.readString();
                        break;
                    case 4:
                        message.target_time = reader.readString();
                        break;
                    case 5:
                        message.target_day_of_week = reader.readEnum();
                        break;
                    case 6:
                        message.unit = reader.readEnum();
                        break;
                    case 7:
                        message.interval = reader.readInt64();
                        break;
                    case 8:
                        message.schedule_rule = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): CronJob {
            return CronJob.deserialize(bytes);
        }
    }
    export class GetTaskRequest extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            task_id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("task_id" in data && data.task_id != undefined) {
                    this.task_id = data.task_id;
                }
            }
        }
        get task_id() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set task_id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            task_id?: string;
        }) {
            const message = new GetTaskRequest({});
            if (data.task_id != null) {
                message.task_id = data.task_id;
            }
            return message;
        }
        toObject() {
            const data: {
                task_id?: string;
            } = {};
            if (this.task_id != null) {
                data.task_id = this.task_id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.task_id === "string" && this.task_id.length)
                writer.writeString(1, this.task_id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetTaskRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetTaskRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.task_id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): GetTaskRequest {
            return GetTaskRequest.deserialize(bytes);
        }
    }
    export class GetTaskResponse extends pb_1.Message {
        #one_of_decls = [];
        constructor(data?: any[] | {
            id?: string;
            encoded_args?: Uint8Array;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("encoded_args" in data && data.encoded_args != undefined) {
                    this.encoded_args = data.encoded_args;
                }
            }
        }
        get id() {
            return pb_1.Message.getField(this, 1) as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get encoded_args() {
            return pb_1.Message.getField(this, 2) as Uint8Array;
        }
        set encoded_args(value: Uint8Array) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            id?: string;
            encoded_args?: Uint8Array;
        }) {
            const message = new GetTaskResponse({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.encoded_args != null) {
                message.encoded_args = data.encoded_args;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                encoded_args?: Uint8Array;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.encoded_args != null) {
                data.encoded_args = this.encoded_args;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (typeof this.id === "string" && this.id.length)
                writer.writeString(1, this.id);
            if (this.encoded_args !== undefined)
                writer.writeBytes(2, this.encoded_args);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetTaskResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetTaskResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.encoded_args = reader.readBytes();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static deserializeBinary(bytes: Uint8Array): GetTaskResponse {
            return GetTaskResponse.deserialize(bytes);
        }
    }
    interface GrpcUnaryServiceInterface<P, R> {
        (message: P, metadata: grpc_1.Metadata, options: grpc_1.CallOptions, callback: grpc_1.requestCallback<R>): grpc_1.ClientUnaryCall;
        (message: P, metadata: grpc_1.Metadata, callback: grpc_1.requestCallback<R>): grpc_1.ClientUnaryCall;
        (message: P, options: grpc_1.CallOptions, callback: grpc_1.requestCallback<R>): grpc_1.ClientUnaryCall;
        (message: P, callback: grpc_1.requestCallback<R>): grpc_1.ClientUnaryCall;
    }
    interface GrpcStreamServiceInterface<P, R> {
        (message: P, metadata: grpc_1.Metadata, options?: grpc_1.CallOptions): grpc_1.ClientReadableStream<R>;
        (message: P, options?: grpc_1.CallOptions): grpc_1.ClientReadableStream<R>;
    }
    interface GrpWritableServiceInterface<P, R> {
        (metadata: grpc_1.Metadata, options: grpc_1.CallOptions, callback: grpc_1.requestCallback<R>): grpc_1.ClientWritableStream<P>;
        (metadata: grpc_1.Metadata, callback: grpc_1.requestCallback<R>): grpc_1.ClientWritableStream<P>;
        (options: grpc_1.CallOptions, callback: grpc_1.requestCallback<R>): grpc_1.ClientWritableStream<P>;
        (callback: grpc_1.requestCallback<R>): grpc_1.ClientWritableStream<P>;
    }
    interface GrpcChunkServiceInterface<P, R> {
        (metadata: grpc_1.Metadata, options?: grpc_1.CallOptions): grpc_1.ClientDuplexStream<P, R>;
        (options?: grpc_1.CallOptions): grpc_1.ClientDuplexStream<P, R>;
    }
    interface GrpcPromiseServiceInterface<P, R> {
        (message: P, metadata: grpc_1.Metadata, options?: grpc_1.CallOptions): Promise<R>;
        (message: P, options?: grpc_1.CallOptions): Promise<R>;
    }
    export abstract class UnimplementedRemoteExecutorService {
        static definition = {
            CreateTask: {
                path: "/remote.RemoteExecutor/CreateTask",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CreateTaskRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CreateTaskRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CreateTaskResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CreateTaskResponse.deserialize(new Uint8Array(bytes))
            },
            CancelTask: {
                path: "/remote.RemoteExecutor/CancelTask",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: CancelTaskRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => CancelTaskRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: CancelTaskResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => CancelTaskResponse.deserialize(new Uint8Array(bytes))
            },
            PostResult: {
                path: "/remote.RemoteExecutor/PostResult",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: PostResultRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => PostResultRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: PostResultResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => PostResultResponse.deserialize(new Uint8Array(bytes))
            },
            WaitForResult: {
                path: "/remote.RemoteExecutor/WaitForResult",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: WaitForResultRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => WaitForResultRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: WaitForResultResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => WaitForResultResponse.deserialize(new Uint8Array(bytes))
            },
            GetTask: {
                path: "/remote.RemoteExecutor/GetTask",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetTaskRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetTaskRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetTaskResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetTaskResponse.deserialize(new Uint8Array(bytes))
            },
            GetSymbolFromEndpoint: {
                path: "/remote.RemoteExecutor/GetSymbolFromEndpoint",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetSymbolFromEndpointRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetSymbolFromEndpointRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetSymbolFromEndpointResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetSymbolFromEndpointResponse.deserialize(new Uint8Array(bytes))
            },
            RegisterApp: {
                path: "/remote.RemoteExecutor/RegisterApp",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: RegisterAppRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => RegisterAppRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: RegisterAppResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => RegisterAppResponse.deserialize(new Uint8Array(bytes))
            },
            DeregisterApp: {
                path: "/remote.RemoteExecutor/DeregisterApp",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: DeregisterAppRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => DeregisterAppRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: DeregisterAppResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => DeregisterAppResponse.deserialize(new Uint8Array(bytes))
            },
            RemoteCall: {
                path: "/remote.RemoteExecutor/RemoteCall",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: RemoteCallRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => RemoteCallRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: RemoteCallResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => RemoteCallResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract CreateTask(call: grpc_1.ServerUnaryCall<CreateTaskRequest, CreateTaskResponse>, callback: grpc_1.sendUnaryData<CreateTaskResponse>): void;
        abstract CancelTask(call: grpc_1.ServerUnaryCall<CancelTaskRequest, CancelTaskResponse>, callback: grpc_1.sendUnaryData<CancelTaskResponse>): void;
        abstract PostResult(call: grpc_1.ServerUnaryCall<PostResultRequest, PostResultResponse>, callback: grpc_1.sendUnaryData<PostResultResponse>): void;
        abstract WaitForResult(call: grpc_1.ServerUnaryCall<WaitForResultRequest, WaitForResultResponse>, callback: grpc_1.sendUnaryData<WaitForResultResponse>): void;
        abstract GetTask(call: grpc_1.ServerUnaryCall<GetTaskRequest, GetTaskResponse>, callback: grpc_1.sendUnaryData<GetTaskResponse>): void;
        abstract GetSymbolFromEndpoint(call: grpc_1.ServerUnaryCall<GetSymbolFromEndpointRequest, GetSymbolFromEndpointResponse>, callback: grpc_1.sendUnaryData<GetSymbolFromEndpointResponse>): void;
        abstract RegisterApp(call: grpc_1.ServerUnaryCall<RegisterAppRequest, RegisterAppResponse>, callback: grpc_1.sendUnaryData<RegisterAppResponse>): void;
        abstract DeregisterApp(call: grpc_1.ServerUnaryCall<DeregisterAppRequest, DeregisterAppResponse>, callback: grpc_1.sendUnaryData<DeregisterAppResponse>): void;
        abstract RemoteCall(call: grpc_1.ServerUnaryCall<RemoteCallRequest, RemoteCallResponse>, callback: grpc_1.sendUnaryData<RemoteCallResponse>): void;
    }
    export class RemoteExecutorClient extends grpc_1.makeGenericClientConstructor(UnimplementedRemoteExecutorService.definition, "RemoteExecutor", {}) {
        constructor(address: string, credentials: grpc_1.ChannelCredentials, options?: Partial<grpc_1.ChannelOptions>) {
            super(address, credentials, options);
        }
        CreateTask: GrpcPromiseServiceInterface<CreateTaskRequest, CreateTaskResponse> = (message: CreateTaskRequest, metadata?: grpc_1.Metadata | grpc_1.CallOptions, options?: grpc_1.CallOptions): Promise<CreateTaskResponse> => { if (!metadata) {
            metadata = new grpc_1.Metadata;
        } if (!options) {
            options = {};
        } return new Promise((resolve, reject) => super.CreateTask(message, metadata, options, (error: grpc_1.ServiceError, response: CreateTaskResponse) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(response);
            }
        })); };
        CancelTask: GrpcPromiseServiceInterface<CancelTaskRequest, CancelTaskResponse> = (message: CancelTaskRequest, metadata?: grpc_1.Metadata | grpc_1.CallOptions, options?: grpc_1.CallOptions): Promise<CancelTaskResponse> => { if (!metadata) {
            metadata = new grpc_1.Metadata;
        } if (!options) {
            options = {};
        } return new Promise((resolve, reject) => super.CancelTask(message, metadata, options, (error: grpc_1.ServiceError, response: CancelTaskResponse) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(response);
            }
        })); };
        PostResult: GrpcPromiseServiceInterface<PostResultRequest, PostResultResponse> = (message: PostResultRequest, metadata?: grpc_1.Metadata | grpc_1.CallOptions, options?: grpc_1.CallOptions): Promise<PostResultResponse> => { if (!metadata) {
            metadata = new grpc_1.Metadata;
        } if (!options) {
            options = {};
        } return new Promise((resolve, reject) => super.PostResult(message, metadata, options, (error: grpc_1.ServiceError, response: PostResultResponse) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(response);
            }
        })); };
        WaitForResult: GrpcPromiseServiceInterface<WaitForResultRequest, WaitForResultResponse> = (message: WaitForResultRequest, metadata?: grpc_1.Metadata | grpc_1.CallOptions, options?: grpc_1.CallOptions): Promise<WaitForResultResponse> => { if (!metadata) {
            metadata = new grpc_1.Metadata;
        } if (!options) {
            options = {};
        } return new Promise((resolve, reject) => super.WaitForResult(message, metadata, options, (error: grpc_1.ServiceError, response: WaitForResultResponse) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(response);
            }
        })); };
        GetTask: GrpcPromiseServiceInterface<GetTaskRequest, GetTaskResponse> = (message: GetTaskRequest, metadata?: grpc_1.Metadata | grpc_1.CallOptions, options?: grpc_1.CallOptions): Promise<GetTaskResponse> => { if (!metadata) {
            metadata = new grpc_1.Metadata;
        } if (!options) {
            options = {};
        } return new Promise((resolve, reject) => super.GetTask(message, metadata, options, (error: grpc_1.ServiceError, response: GetTaskResponse) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(response);
            }
        })); };
        GetSymbolFromEndpoint: GrpcPromiseServiceInterface<GetSymbolFromEndpointRequest, GetSymbolFromEndpointResponse> = (message: GetSymbolFromEndpointRequest, metadata?: grpc_1.Metadata | grpc_1.CallOptions, options?: grpc_1.CallOptions): Promise<GetSymbolFromEndpointResponse> => { if (!metadata) {
            metadata = new grpc_1.Metadata;
        } if (!options) {
            options = {};
        } return new Promise((resolve, reject) => super.GetSymbolFromEndpoint(message, metadata, options, (error: grpc_1.ServiceError, response: GetSymbolFromEndpointResponse) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(response);
            }
        })); };
        RegisterApp: GrpcPromiseServiceInterface<RegisterAppRequest, RegisterAppResponse> = (message: RegisterAppRequest, metadata?: grpc_1.Metadata | grpc_1.CallOptions, options?: grpc_1.CallOptions): Promise<RegisterAppResponse> => { if (!metadata) {
            metadata = new grpc_1.Metadata;
        } if (!options) {
            options = {};
        } return new Promise((resolve, reject) => super.RegisterApp(message, metadata, options, (error: grpc_1.ServiceError, response: RegisterAppResponse) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(response);
            }
        })); };
        DeregisterApp: GrpcPromiseServiceInterface<DeregisterAppRequest, DeregisterAppResponse> = (message: DeregisterAppRequest, metadata?: grpc_1.Metadata | grpc_1.CallOptions, options?: grpc_1.CallOptions): Promise<DeregisterAppResponse> => { if (!metadata) {
            metadata = new grpc_1.Metadata;
        } if (!options) {
            options = {};
        } return new Promise((resolve, reject) => super.DeregisterApp(message, metadata, options, (error: grpc_1.ServiceError, response: DeregisterAppResponse) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(response);
            }
        })); };
        RemoteCall: GrpcPromiseServiceInterface<RemoteCallRequest, RemoteCallResponse> = (message: RemoteCallRequest, metadata?: grpc_1.Metadata | grpc_1.CallOptions, options?: grpc_1.CallOptions): Promise<RemoteCallResponse> => { if (!metadata) {
            metadata = new grpc_1.Metadata;
        } if (!options) {
            options = {};
        } return new Promise((resolve, reject) => super.RemoteCall(message, metadata, options, (error: grpc_1.ServiceError, response: RemoteCallResponse) => {
            if (error) {
                reject(error);
            }
            else {
                resolve(response);
            }
        })); };
    }
}
